import * as React from 'react';

export interface BrandMarkProps extends React.SVGAttributes<SVGSVGElement> {
  /** Rendered width/height in px (square). Default 32. */
  size?: number;
  ref?: React.Ref<SVGSVGElement>;
}

/**
 * BrandMark ï¿½ the Genesis brand glyph: the four-node "agents around a
 * coordinator" mark (navy rings, blue nodes). The image is served
 * from `/logo.png` (`apps/ui/web/public` and the Storybook `static/` dir) so
 * it stays out of the library bundle. Exposed as role="img" with a fixed accessible name.
 */
export function BrandMark({ size = 32, ref, ...props }: BrandMarkProps) {
  return (
    <svg
      ref={ref}
      viewBox="0 0 32 32"
      width={size}
      height={size}
      role="img"
      aria-label="Agentis Genesis"
      {...props}
    >
      <image href="/logo.png" width="32" height="32" />
    </svg>
  );
}
BrandMark.displayName = 'BrandMark';
